var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var THREE                    = require("three");

/**
 * @constructor
 */
var Camera3dStateMachine = function (root, model) {
    var self = this;
    self.root = root;

    this.model = model;

    lib_core.StateMachine.call(this);

    this.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_WHEEL);
        },
        function(cEvent){
            var mouseWheenEvent = cEvent.data("jsEvent");
            self.onMouseWheel(mouseWheenEvent);
        }
    );

    // begin moving camera if canvas mouse down and not over element
    this.addTransition("idle","movingCamera",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN );
        },
        function(cEvent){
            var mouseDownEvent = cEvent.data("jsEvent");
            self.onMouseDown(mouseDownEvent);
        }
    );

    this.addTransition("movingCamera","movingCamera",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE)
        },
        function(cEvent){
            var mouseMoveEvent = cEvent.data("jsEvent");
            var canvasWidth = cEvent.data("canvasWidth");
            var canvasHeight = cEvent.data("canvasHeight");
            self.onMouseMove(mouseMoveEvent, canvasWidth, canvasHeight);
        }
    );

    this.addTransition("movingCamera","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP);
        },
        function(cEvent){
            var mouseUpEvent = cEvent.data("jsEvent");
            self.onMouseUp(mouseUpEvent);
        }
    );

    this.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.CAMERA_SWITCH);
        },
        function(cEvent){
            if(self.model.cameraType() == 0){
                self.model.cameraType(1);
            } else if(self.model.cameraType() == 1){
                self.model.cameraType(0);
            }
        }
    );

    this.rotateStart = new THREE.Vector2();
    this.rotateEnd = new THREE.Vector2();
    this.rotateDelta = new THREE.Vector2();
    this.panStart = new THREE.Vector2();
    this.panEnd = new THREE.Vector2();
    this.panDelta = new THREE.Vector2();

};


lib_core.inherit(Camera3dStateMachine, lib_core.StateMachine);
module.exports = Camera3dStateMachine;


Camera3dStateMachine.prototype.onMouseDown = function(info){
    if(info.button == 0){
        this.rotateStart.set( info.clientX, info.clientY );
        this.model.state("orbit");

    } else if(info.button == 2){
        this.panStart.set( info.clientX, info.clientY );
        this.model.state("pan");
    }
}

Camera3dStateMachine.prototype.onMouseMove = function(info, width, height){
    var xMult = 1;
    var yMult = 1;
    if(width){
        xMult = 2000/width;
    }
    if(height){
        yMult = 1500/height;
    }
    
    if(this.model.state() == "orbit"){
        this.rotateEnd.set( info.clientX, info.clientY );
        this.rotateDelta.subVectors( this.rotateEnd, this.rotateStart );

        this.model.rotateLeft( 2 * Math.PI * this.rotateDelta.x * this.model.rotateSpeed * xMult);

        this.model.rotateUp( 2 * Math.PI * this.rotateDelta.y * this.model.rotateSpeed * yMult);

        this.rotateStart.copy( this.rotateEnd );

    } else if(this.model.state() == "pan"){

        this.panEnd.set( info.clientX, info.clientY );

        this.panDelta.subVectors( this.panEnd, this.panStart );

        this.model.pan( this.panDelta.x * xMult, this.panDelta.y * yMult);

        this.panStart.copy( this.panEnd );
    }
}

Camera3dStateMachine.prototype.onMouseUp = function(info){
    this.model.state("none");
}

Camera3dStateMachine.prototype.onMouseWheel = function(info){
    if ( info.wheelDelta < 0 ) {
        this.model.zoomOut( this.model.zoomSpeed );
    } else if ( info.wheelDelta > 0 ) {
        this.model.zoomIn( this.model.zoomSpeed );
    }
}










